import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-icon-produce',
  templateUrl: './icon-produce.component.html',
  styleUrls: ['./icon-produce.component.scss']
})
export class IconProduceComponent implements OnInit {

  @Input() cssClass = 'icon--18';
  
  constructor() { }

  ngOnInit() {
  }

}
